export default __webpack_public_path__ + "static/Plain-Regular-30eb6b3f14fe53aa2b6a864f48c3da27.woff";